import React from "react";
import { Affix } from "antd";

const CustomAffix = ({ className, offsetBottom, children }) => (
  <Affix className={className} offsetBottom={offsetBottom}>
    {children}
  </Affix>
);
export default CustomAffix;
